import React from 'react';
import { Tooltip } from '@getro/rombo';
import { useDispatch } from 'react-redux';
import { Flex, Box } from 'rebass/styled-components';
import { Search, SidebarClose } from 'lucide-react';
import PropTypes from 'prop-types';

import { toggleMenu } from '../../../features/mainMenu';
import { NetworkOption } from '../NetworkOption';
import { UniversalSearch } from '../../organisms/universalSearch';
import { useUniversalSearch } from '../../organisms/universalSearch/hooks/useUniversalSearch';

export const NavHeader = ({ activeNetwork }) => {
  const { isManager, connect } = activeNetwork || {};
  const dispatch = useDispatch();
  const isMac = typeof navigator !== 'undefined' && /Mac/i.test(navigator.userAgent);
  const { open, setOpen, isSearchAvailable } = useUniversalSearch();

  return (
    <>
      <Flex
        py="12px"
        pl="8px"
        pr="4px"
        flexShrink={0}
        alignItems="center"
        justifyContent="space-between"
        sx={{
          gap: '4px',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <NetworkOption />
        <Flex flex="0 0 auto" alignItems="center">
          {isManager && connect?.hasAccess && (
            <Tooltip
              position="bottom-start"
              trigger={
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  flex="0 0 auto"
                  width="24px"
                  height="24px"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => setOpen(true)}
                >
                  <Box as={Search} width="16px" height="16px" aria-hidden="true" sx={{ color: 'neutral.500' }} />
                </Flex>
              }
              content={`Quick search · ${isMac ? '⌘K' : 'Ctrl+K'}`}
            />
          )}
          <Tooltip
            position="bottom-start"
            trigger={
              <Flex
                className="main-menu-close-icon"
                alignItems="center"
                justifyContent="center"
                flex="0 0 auto"
                width="24px"
                height="24px"
                sx={{ cursor: 'pointer' }}
                onClick={() => dispatch(toggleMenu())}
              >
                <Box
                  as={SidebarClose}
                  className="main-menu-item"
                  width="16px"
                  height="16px"
                  aria-hidden="true"
                  sx={{ color: 'neutral.500' }}
                />
              </Flex>
            }
            content="Collapse sidebar"
          />
        </Flex>
      </Flex>
      {isSearchAvailable && <UniversalSearch open={open} onOpenChange={setOpen} />}
    </>
  );
};

NavHeader.propTypes = {
  activeNetwork: PropTypes.object.isRequired,
};
